import { theme } from '@/styles/theme'

interface CheckIconProps {
  checked?: boolean
  disabled?: boolean
}

export default function CheckIcon({ checked = false, disabled = false }: CheckIconProps) {
  const strokeColor = disabled ? theme.palette.gray[300] : theme.palette.primary[400]
  const fillColor = checked ? strokeColor : 'none'
  const checkMarkColor = checked ? 'white' : 'none'

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <circle cx="9" cy="9" r="8.5" stroke={strokeColor} fill={fillColor} />
      {checked && (
        <path
          d="M5.46436 9L8.29278 11.8284L12.5354 7.58579"
          stroke={checkMarkColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  )
}
